import { Component, inject } from '@angular/core';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CreatorCardBlueComponent } from '../../../creators/molecules/creator-card-blue/creator-card-blue.component';

@Component({
  selector: 'cv2-filtered-creators',
  standalone: true,
  imports: [InfiniteScrollModule, CreatorCardBlueComponent],
  templateUrl: './filtered-creators.component.html',
  styleUrl: './filtered-creators.component.css'
})
export class FilteredCreatorsComponent {

  // SCROLL CONFIG
  throttle = 100;
  scrollDistance = 2;
  scrollUpDistance = 2;

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  /** Services - END */ 

  /** Scroll Events */
  onScrollDownBlue($event: any) {
    console.log('💙💙💙 onScrollDownBlue: ', $event);
    // Increment page number for pagination
    this.magicSearchService.pageNumber.update(prev => prev + 1);
    // Call search with pagination flag - service will check if searchQuery/filters changed
    this.magicSearchService.kickOffBlueSearch(
      this.magicSearchService.appliedFilters ? this.magicSearchService.appliedFilters : undefined,
      true // isPagination = true
    );
  }
}
